export const apiUrl = 'http://192.168.1.28:9041';
export const countriesReq = 'api/helper/countries';

export const successPageIcon =
  'https://i.simpalsmedia.com/point.md/news/thumbnails/large/1b03e1c5b8e381840a41c7fe78d09622.webp';
export const failPageIcon =
  'https://i.simpalsmedia.com/point.md/news/thumbnails/large/d2e9cc11ff01424035b859ded9abb877.webp';

export const devUrl = 'http://container--easig.tag--dev.port--9041.docker.simpals.com/';
